export default __webpack_public_path__ + "static/media/permit_pending.411dd97b.svg";